import { defineStore } from 'pinia';
import { useNuxtApp } from "#app";
import { ArticleCategoryCollectionType } from "~/types/article/ArticleCategoryCollectionType";
import { ArticleCategoryType } from "~/types/article/ArticleCategoryType";

export const useArticleCategoryCollectionStore = defineStore({
    id: 'articleCategoryCollection',
    state: (): ArticleCategoryCollectionType => ({
        list: undefined,
        error: undefined,
    }),
    getters: {},
    actions: {
        async fetchList() {
            if (this.list !== undefined) {
                return true;
            }

            try {
                const fields = ['title', 'slug'];
                const sort = ['sorting:desc'];
                const response = await useNuxtApp().axios.get('/interesting-facts-categories', {
                    params: {
                        fields,
                        sort,
                    }
                });
                if (response?.data?.data === undefined) {
                    this.error = createError({ statusCode: 404, statusMessage: 'Page Not Found' });
                    return false;
                }

                if (!response?.data?.data.length) {
                    this.list = [];
                    this.error = 'Empty list.';
                    return false;
                }

                this.list = response?.data?.data.map(item => <ArticleCategoryType>({
                    title: item?.attributes?.title,
                    slug: item?.attributes?.slug,
                    url: `/interesting-facts/category-${item?.attributes?.slug}`
                }));
                this.error = undefined;
            } catch (error) {
                console.log(error);
                this.error = createError({ statusCode: 500, statusMessage: 'Internal error' });
            }

            return true;
        }
    },
});
